import { Box, styled } from '@mui/material';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { OrBlockProps } from './or-block.types';
import { AndBlock } from '../and-block/and-block';
import { AddBlockButton } from '../add-block-button/add-block-button';
import { BlockHeader } from '../block-header/block-header';
import { EnrollNodeFormValues, EntityType } from '../../enroll-node-editor.types';
import { getUsedEntityTypes } from '../../utils';

const entityTypeOptions: { label: string; value: EntityType }[] = [
  { label: 'Branch Office', value: 'branchOfficeIds' },
  { label: 'Job Type', value: 'jobTypeIds' },
];

export const OrBlock = ({ index, canRemove, onRemove, entityOptions }: OrBlockProps) => {
  const { control } = useFormContext<EnrollNodeFormValues>();

  const andArray = useFieldArray({
    control,
    name: `orBlocks.${index}.andBlocks`,
  });

  const watchedAndBlocks = useWatch({
    control,
    name: `orBlocks.${index}.andBlocks`,
  });

  const usedEntityTypes = getUsedEntityTypes(watchedAndBlocks);

  return (
    <OrBlockWrapper data-testid={`or-block-${index}`}>
      <BlockHeader title={`OR condition #${index + 1}`} onRemove={onRemove} canRemove={canRemove} />
      <AndBlocksWrapper>
        {andArray.fields.map((f, andIndex) => (
          <AndBlock
            entityTypeOptions={entityTypeOptions}
            entityOptions={entityOptions}
            usedEntityTypes={usedEntityTypes}
            key={f.id}
            orIndex={index}
            andIndex={andIndex}
            canRemove={andArray.fields.length > 1}
            onRemove={() => andArray.remove(andIndex)}
          />
        ))}
        <AddBlockButton
          onClick={() =>
            andArray.append({ condition: 'equal', entityId: [], entityType: 'branchOfficeIds' })
          }
          disabled={usedEntityTypes.length >= entityTypeOptions.length}
          label="AND"
        />
      </AndBlocksWrapper>
    </OrBlockWrapper>
  );
};

const OrBlockWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  border: `1px solid ${theme.palette.lwPrimaryAccentLight[100]}`,
  borderRadius: 12,
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 16,
  width: '100%',
  flexShrink: 0,
}));

const AndBlocksWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: '100%',
}));
